var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"katexBox",attrs:{"id":_vm.id ? _vm.id : _vm.randomId},domProps:{"innerHTML":_vm._s(_vm.fomula)}})
}
var staticRenderFns = []

export { render, staticRenderFns }